import Tr from 'translations/Translations';



export const VALUES = {
	ALL: '',
	PREPARING: 'PREPARING',
	MODIFICATION: 'MODIFICATION',
	OFFER_COLLECTION: 'OFFER_COLLECTION',
	OFFER_DECRYPTION: 'OFFER_DECRYPTION',
	OFFER_EVALUATION: 'OFFER_EVALUATION',
	FINISHING: 'FINISHING',
	CANCELLED: 'CANCELLED',
	ANNULLED: 'ANNULLED',
	FINISHED: 'FINISHED'
}

export const LABELS = {
	[VALUES.ALL]: Tr('procedure_status_0'),
	[VALUES.PREPARING]: Tr('procedure_status_1'),
	[VALUES.OFFER_COLLECTION]: Tr('procedure_status_2'),
	[VALUES.MODIFICATION]: Tr('procedure_status_3'),
	[VALUES.OFFER_DECRYPTION]: Tr('procedure_status_4_0'),
	[VALUES.OFFER_EVALUATION]: Tr('procedure_status_4'),
	[VALUES.FINISHING]: Tr('procedure_status_5'),
	[VALUES.FINISHED]: Tr('procedure_status_7'),
	[VALUES.ANNULLED]: Tr('procedure_status_8'),
	[VALUES.CANCELLED]: Tr('procedure_status_6'),
}

const createItem = (e) => ({
	label: LABELS[e],
	value: e,
})

export default Object.values(VALUES).map( x => createItem(x))
